export class Langue{
  id: number;
  libelle: string;
  etat: boolean;
}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/models/langue.ts